import React from "react";
import "./CustomLabelSection.css";

import { TextWithLineBreaks } from "../TextWithLineBreaks";


const CustomLabelSection = ({label = null}) => {
  return (
    <div className="custom-label-section-container">
        <section className="custom-label-section">
            <div className="custom-label-section-label">
                <TextWithLineBreaks text={label} />
            </div>
        </section>
    </div>
  );
};

export default CustomLabelSection;
